import { FC, memo, useMemo } from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

import { Link } from 'components'
import { ORIGIN_URL_QUERY } from 'constants/queryString'
import { UNIFIED_LOGIN_URL } from 'constants/urls'
import { encrypt } from 'utils/crypto'
import { ArrowRight } from 'components/icons'

const GoToAuthenticationButton: FC<ButtonProps> = (props) => {
  const pathToAuthenticator = useMemo(() => {
    return {
      pathname: UNIFIED_LOGIN_URL,
      query: { [ORIGIN_URL_QUERY]: encrypt(window.location.href) },
    }
  }, [])

  return (
    <Link href={pathToAuthenticator} display="flex" justifyItems="center" justifyContent="center">
      <Button rightIcon={<ArrowRight />} tabIndex={-1} {...props}>
        Entrar
      </Button>
    </Link>
  )
}

export default memo(GoToAuthenticationButton)
